"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Route = void 0;
exports.convertQueryParams = convertQueryParams;
exports.safeAddParamsToQuery = safeAddParamsToQuery;
const path_to_regexp_1 = require("path-to-regexp");
const UrlHelper_1 = require("../UrlHelper/UrlHelper");
const ObjectHelper_1 = require("../../objects/ObjectHelper");
/**
 * Converts a `ParsedUrlQuery` into `URLSearchParams`
 *
 * @param params the params to convert
 */
function convertQueryParams(params) {
    const finalQueryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach(subValue => {
                finalQueryParams.append(key, subValue);
            });
        }
        else if (value != null) {
            finalQueryParams.append(key, value);
        }
    });
    return finalQueryParams;
}
/**
 * Adds a path param as a query param and prevents a path param that has the same
 * key as a query param. This is done because the path params are sent as query params
 * when using the next/link component via the "href".
 *
 * @param params the path params
 * @param query the query params
 */
function safeAddParamsToQuery(params, query) {
    const captured = {};
    if (params) {
        Object.entries(params).forEach(([key, value]) => {
            if (query[key]) {
                throw new Error('A path param key is not allowed to match a query param key.');
            }
            if (value != null) {
                captured[key] = value.toString();
            }
        });
    }
    return Object.assign(Object.assign({}, query), captured);
}
/**
 * Combines a path and a query string.
 *
 * @param path the path.
 * @param query the query object.
 */
function createPath(path, query) {
    if (!(0, ObjectHelper_1.isObjectEmpty)(query)) {
        const queryParams = convertQueryParams(query);
        // check if there are any valid query params before appending query
        if (queryParams.keys().next().done !== true) {
            return `${path}?${queryParams}`;
        }
    }
    return path;
}
/**
 * A Route for use in a NextJs application.
 */
class Route {
    constructor(name, pattern, page) {
        this.name = name;
        this.page = page.replace(/(^|\/)index$/, '').replace(/^\/?/, '/');
        this.toPath = (0, path_to_regexp_1.compile)(pattern, { encode: UrlHelper_1.safeEncodeUriComponent });
        this.match = (0, path_to_regexp_1.match)(pattern, { decode: UrlHelper_1.safeDencodeUriComponent });
    }
    /**
     * Creates a relative path that uses the internal page path and includes the path
     * params and query params both as query params. This should only be used when using the
     * NextJs Link or Router and in both cases the value of `getRelativeUrl` should be supplied
     * as the "as" value.
     *
     * @param params the path params.
     * @param query the query params.
     */
    getInternalRelativeUrl(params = {}, query = {}) {
        const updatedQuery = safeAddParamsToQuery(params, query);
        return createPath(this.page, updatedQuery);
    }
    /**
     * A relative URL for a given route.
     *
     * @param params the path params.
     * @param query the query params.
     */
    getRelativeUrl(params, query = {}) {
        const as = this.toPath(params) || '/';
        return createPath(as, query);
    }
}
exports.Route = Route;
//# sourceMappingURL=Route.js.map